enum Integration
{
	HomeAutomation = 1,
	Photovoltaics = 2,
	BatteryStorage = 3,
	ChargingProcessAccountance = 4,
	NoIntegration = 5,
}

export default Integration;